import { createContext, useContext } from 'react';

interface PublicationDrawerContextValue {
  open: (publicationId: number) => void;
  close: () => void;
}

/** Defaults to no-ops so references rendered outside the provider (tests,
 * the login screen) stay inert instead of throwing. */
export const PublicationDrawerContext =
  createContext<PublicationDrawerContextValue>({
    open: () => undefined,
    close: () => undefined,
  });

export const usePublicationDrawer = () => useContext(PublicationDrawerContext);
